var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"head"},[_c('span',{staticClass:"titleText"},[_vm._v(_vm._s(_vm.$t('coordinationParticipant.audioSetting')))]),_c('i',{staticClass:"iconfont icon-Cancel pointer",on:{"click":function($event){return _vm.visibleChange()}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }